import type {
  AssignAdministratorRequest,
  EnvelopeClassificationRequest,
  OtherLocationRequest,
} from "../../../models/ProgramRequest";

export const createDefaultAssignAdministratorRequest =
  (): AssignAdministratorRequest => ({
    envelopeId: 0,
    administratorId: undefined,
  });

export const createDefaultEnvelopeClassificationRequest =
  (): EnvelopeClassificationRequest => ({
    envelopeId: 0,
    classificationMark: "",
    registryNumber: "",
    registrationDate: new Date(),
  });

export const createDefaultOtherLocationRequest = (): OtherLocationRequest => ({
  programRequestId: 0,
  programRequestDetailId: 0,
  institutionLocationDetailIds: [],
});

